import React from 'react';
import { ChefHat, HelpCircle } from 'lucide-react';

const KitchenLocationStep = ({ value, onChange }) => {
  const gridDirections = [
    ['NW', 'N', 'NE'],
    ['W', 'Center', 'E'],
    ['SW', 'S', 'SE']
  ];

  const specialOptions = [
    { id: 'open-kitchen', label: 'Open kitchen near living room', icon: ChefHat },
    { id: 'unsure', label: 'Not sure / No idea', icon: HelpCircle }
  ];

  return (
    <div>
      <h3 className="text-2xl font-bold text-[#232323] mb-2">Roughly where is your kitchen?</h3>
      <p className="text-[#353535] mb-6">Tap the approximate direction where your kitchen is located.</p>
      
      {/* Direction grid */}
      <div className="flex justify-center mb-6">
        <div className="grid grid-cols-3 gap-3 p-6 bg-white rounded-xl border-2 border-gray-200">
          {gridDirections.map((row, rowIdx) => (
            row.map((dir, colIdx) => {
              const cellId = dir.toLowerCase().replace(' ', '-');
              const isSelected = value === cellId;
              
              return (
                <button
                  key={`${rowIdx}-${colIdx}`}
                  onClick={() => onChange(cellId)}
                  className={`w-24 h-24 rounded-lg border-2 font-bold text-sm transition-all hover:scale-105 ${
                    isSelected
                      ? 'bg-[#232323] text-white border-[#232323]'
                      : 'bg-white text-[#232323] border-gray-300 hover:border-[#232323]'
                  } ${
                    dir === 'Center' ? 'opacity-50' : ''
                  }`}
                  disabled={dir === 'Center'}
                >
                  <div className="flex flex-col items-center justify-center">
                    <ChefHat className="w-6 h-6 mb-1" />
                    <span>{dir}</span>
                  </div>
                </button>
              );
            })
          ))}
        </div>
      </div>

      {/* Special options */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {specialOptions.map((option) => {
          const Icon = option.icon;
          const isSelected = value === option.id;
          
          return (
            <button
              key={option.id}
              onClick={() => onChange(option.id)}
              className={`p-4 border-2 rounded-xl text-left transition-all hover:shadow-md ${
                isSelected
                  ? 'border-[#232323] bg-[var(--accent-saffron)]'
                  : 'border-gray-200 hover:border-[#999999]'
              }`}
            >
              <div className="flex items-center gap-3">
                <Icon className="w-5 h-5 text-[#232323]" />
                <span className="font-semibold text-[#232323]">{option.label}</span>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default KitchenLocationStep;